
      import { pageLocationForAnalytics } from '/src/lib/analytics.ts';
      (function () {
        var host = location.hostname.replace(/\.$/, '').toLowerCase();
        var allowed = host === 'www.milkywayplanner.com' || host === 'milkywayplanner.com';
        if (!allowed || navigator.webdriver) return;
        window.dataLayer = window.dataLayer || [];
        function gtag(){dataLayer.push(arguments);}
        window.gtag = gtag;
        gtag('js', new Date());
        gtag('config', 'G-PDEHHK9F0X', {
          page_location: pageLocationForAnalytics(location.href)
        });
        var script = document.createElement('script');
        script.async = true;
        script.src = 'https://www.googletagmanager.com/gtag/js?id=G-PDEHHK9F0X';
        document.head.appendChild(script);
      })();
    